import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const ButtonTableType = (props) => {
  return (
    <Button className="pull-right table-new-button" color="primary" onClick={props.handleButtonClick}>
      {props.isTable ? <i className="fa fa-th" /> : <i className="fa fa-th-list" />}
    </Button>
  );
};

ButtonTableType.propTypes = {
  handleButtonClick: PropTypes.func.isRequired,
  isTable: PropTypes.bool.isRequired
};

export default ButtonTableType;
